import DeleteIcon from 'assets/Icons/delete/DeleteIcons';
import BackIcon from 'assets/Icons/modals/BackIcon';
import PrimaryButton from 'components/elements/Form/button/primaryButton';
import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import Modal from 'components/elements/Modal';
import React from 'react';
import useDeleteOccupant from './crud/useDelete';
import { toast } from 'react-toastify';
import { generateDeleteErrorMessage, generateDeleteSuccessMessage } from 'utils/helpers';

type DeleteProps = {
  entityName: string;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteUUID: React.Dispatch<React.SetStateAction<string>>;
  deleteUUID?: string;
  deleteQuery: any;
  queryName: string;
};

export default function Delete({
  entityName,
  showModal,
  setShowModal,
  setDeleteUUID,
  deleteUUID,
  deleteQuery,
  queryName
}: DeleteProps) {
  const deleteOccupantMutation = useDeleteOccupant({
    deleteQuery,
    queryName,
    removeOnSuccess: true
  });

  const handleDelete = () => {
    setShowModal(false);
    toast
      .promise(
        // Call the mutate function by passing in the necessary arguments
        () => deleteOccupantMutation.mutateAsync(deleteUUID),
        {
          pending: 'Deleting Occupant...',
          success: generateDeleteSuccessMessage('Occupant'),
          error: generateDeleteErrorMessage('Occupant')
        }
      )
      .then(() => {
        // Handling after success
        setDeleteUUID('');
      })
      .catch(() => {
        // Handling after error
        setDeleteUUID('');
      });
  };

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false);
          if (setDeleteUUID) setDeleteUUID('');
        }}
      >
        <div className="flex flex-col items-center">
          <div className="delete-icon">
            <DeleteIcon />
          </div>
          <h1 className="mt-4">Are you sure?</h1>
          <p>{`Are you sure you want to delete this ${entityName.toLowerCase()}?`}</p>
          <div className="flex justify-between space-x-2">
            <SecondaryButton
              buttonLabel="Back"
              iconLeft={<BackIcon />}
              variant="default"
              size="px-4 w-full"
              onClick={() => {
                setShowModal(false);
                setDeleteUUID('');
              }}
            />
            <PrimaryButton
              buttonLabel="Delete"
              onClick={handleDelete}
              variant="default"
              size="px-4 w-auto gap-2"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}
